export const EXPRESSIONS_DICTIONARY = {
  choose: 'Wybierz',
  delete: 'Usuń',
  titleAdults: 'Dorośli',
  titleChildren: 'Dzieci',
  clearAll: 'Wyczyść wszystko',
  chooseBirthday: 'Wybierz datę urodzenia',
}



// WEBPACK FOOTER //
// ./src/modules/dictionaries.js